import { Component } from '@lisergia/core'
import { Viewport } from '@lisergia/managers'

import GSAP from 'gsap'

export default class extends Component {
  declare classes: {
    paginationButtonsActive: string
  }

  declare element: HTMLDivElement

  declare elements: {
    contentContainer: HTMLDivElement
    items: NodeListOf<HTMLDivElement>
    paginationButtonsDesktop: NodeListOf<HTMLButtonElement>
    paginationButtonsPhone: NodeListOf<HTMLButtonElement>
    buttonPrevious: HTMLButtonElement
    buttonNext: HTMLButtonElement
  }

  constructor({ element }: { element: HTMLElement }) {
    super({
      classes: {
        paginationButtonsActive: 'bento__pagination__button--active',
      },
      element,
      elements: {
        contentContainer: '.bento__content__container',
        items: '.bento__item',
        buttonPrevious: '.bento__button--previous',
        buttonNext: '.bento__button--next',
        paginationButtonsDesktop: '.bento__pagination--desktop .bento__pagination__button',
        paginationButtonsPhone: '.bento__pagination--phone .bento__pagination__button',
      },
    })

    if (Viewport.isPhone) {
      this.onScroll()
    } else {
      this.onChange(0)
    }
  }

  index: number = 0

  onChange(index: number) {
    const elementsVisible: HTMLElement[] = []
    const elementsHidden: HTMLElement[] = []

    this.elements.items.forEach((item, itemIndex) => {
      const elements = item.querySelectorAll<HTMLElement>('.bento__entry')

      if (Math.floor(itemIndex / 3) === index) {
        elementsVisible.push(...Array.from(elements))
      } else {
        elementsHidden.push(...Array.from(elements))
      }
    })

    GSAP.to(elementsVisible, {
      autoAlpha: 1,
      delay: 0.2,
      duration: 1.2,
      ease: 'elastic(1, 0.75)',
      scale: 1,
      stagger: 0.1,
    })

    GSAP.to(elementsHidden, {
      autoAlpha: 0,
      duration: 1.2,
      ease: 'elastic(1, 0.75)',
      scale: 0.9,
      stagger: 0.1,
    })

    this.elements.paginationButtonsDesktop.forEach((button, buttonIndex) => {
      if (buttonIndex === index) {
        button.classList.add(this.classes.paginationButtonsActive)
      } else {
        button.classList.remove(this.classes.paginationButtonsActive)
      }
    })

    this.index = index
  }

  onNext() {
    const index = this.index + 1 >= this.elements.paginationButtonsDesktop.length ? 0 : this.index + 1

    this.onChange(index)
  }

  onPrevious() {
    const index = this.index - 1 < 0 ? this.elements.paginationButtonsDesktop.length - 1 : this.index - 1

    this.onChange(index)
  }

  onPaginateDesktop(event: Event) {
    const index = Array.from(this.elements.paginationButtonsDesktop).indexOf(event.currentTarget as HTMLButtonElement)

    this.onChange(index)
  }

  onPaginatePhone(event: Event) {
    const index = Array.from(this.elements.paginationButtonsPhone).indexOf(event.currentTarget as HTMLButtonElement)
    const width = this.elements.contentContainer.offsetWidth

    this.elements.contentContainer.scrollTo({
      left: index * width,
      behavior: 'smooth',
    })
  }

  onScroll() {
    const scrollLeft = this.elements.contentContainer.scrollLeft
    const width = this.elements.contentContainer.offsetWidth

    const index = Math.round(scrollLeft / width)

    this.elements.paginationButtonsPhone.forEach((button, buttonIndex) => {
      if (buttonIndex === index) {
        button.classList.add(this.classes.paginationButtonsActive)
      } else {
        button.classList.remove(this.classes.paginationButtonsActive)
      }
    })
  }

  addEventListeners() {
    this.elements.contentContainer.addEventListener('scroll', this.onScroll)

    this.elements.paginationButtonsPhone.forEach((button, index) => {
      button.addEventListener('click', this.onPaginatePhone)
    })

    this.elements.paginationButtonsDesktop.forEach((button, index) => {
      button.addEventListener('click', this.onPaginateDesktop)
    })

    this.elements.buttonNext.addEventListener('click', this.onNext)
    this.elements.buttonPrevious.addEventListener('click', this.onPrevious)
  }

  removeEventListeners() {
    this.elements.contentContainer.removeEventListener('scroll', this.onScroll)

    this.elements.paginationButtonsPhone.forEach((button, index) => {
      button.addEventListener('click', this.onPaginatePhone)
    })

    this.elements.paginationButtonsDesktop.forEach((button) => {
      button.removeEventListener('click', this.onPaginateDesktop)
    })

    this.elements.buttonNext.removeEventListener('click', this.onNext)
    this.elements.buttonPrevious.removeEventListener('click', this.onPrevious)
  }
}
